import { render, staticRenderFns } from "./RequestDetailForm.vue?vue&type=template&id=7abf185b&scoped=true"
import script from "./RequestDetailForm.vue?vue&type=script&lang=ts"
export * from "./RequestDetailForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abf185b",
  null
  
)

export default component.exports